import { render, staticRenderFns } from "./link_wrapper.vue?vue&type=template&id=163fb168&"
import script from "./link_wrapper.vue?vue&type=script&lang=js&"
export * from "./link_wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports